import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  GET_DUNING_GAS_REPORT,
  EMAIL_NOTIFY_DISCONNECTION,
  GET_DISC_DUNING_GAS_REPORT
} from "../../../../Urls.js";

const initialState = {
  disconnection: { data: [], loading: false, successMessage: "" },
  disconnectedUsers: { data: [], loading: false, successMessage: "" },
  emailDisconnection: { data: [], loading: false, successMessage: "" },
};

export const getDunningGasReport = createAsyncThunk(
  "app/dailySales/getDunningGasReport",
  async (payload) => {
    const response = await axios.get(`${GET_DUNING_GAS_REPORT}`, {
      params: payload,
    });
    return response;
  }
);
export const getDiscDunningGasReport = createAsyncThunk(
  "app/dailySales/getDiscDunningGasReport",
  async (payload) => {
    const response = await axios.get(`${GET_DISC_DUNING_GAS_REPORT}`, {
      params: payload,
    });
    return response;
  }
);

export const emailNofifyDisconnection = createAsyncThunk(
  "app/dailySales/emailNofifyDisconnection",
  async (data) => {
    const response = await axios.post(EMAIL_NOTIFY_DISCONNECTION, { ...data });
    return response;
  }
);

export const dailySales = createSlice({
  name: "dailySales",
  initialState,
  reducers: {
    clearSuccessMessage: (state) => {
      // state.disconnection.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDunningGasReport.pending, (state) => {
        state.disconnection.loading = true;
      })
      .addCase(getDunningGasReport.fulfilled, (state, action) => {
        state.disconnection.loading = false;
        state.disconnection.data = action?.payload?.data?.data?.map((item) => ({
          ...item,
          sentStatus: "",
        }));
      })
      .addCase(getDunningGasReport.rejected, (state) => {
        state.disconnection.loading = false;
      })
       .addCase(getDiscDunningGasReport.pending, (state) => {
        state.disconnectedUsers.loading = true;
      })
      .addCase(getDiscDunningGasReport.fulfilled, (state, action) => {
        state.disconnectedUsers.loading = false;
        state.disconnectedUsers.data = action?.payload?.data?.data
      })
      .addCase(getDiscDunningGasReport.rejected, (state) => {
        state.disconnectedUsers.loading = false;
      })
      .addCase(emailNofifyDisconnection.pending, (state) => {
        state.emailDisconnection.loader = true;
      })
      .addCase(emailNofifyDisconnection.fulfilled, (state, action) => {
        state.emailDisconnection.loader = false;
        state.emailDisconnection.data = action?.payload?.data?.data;
        state.emailDisconnection.successMessage = "Email sent successfully!";
      })
      .addCase(emailNofifyDisconnection.rejected, (state) => {
        state.emailDisconnection.loader = false;
        state.emailDisconnection.data = {};
        state.emailDisconnection.successMessage = "Failed to sent Email!";
      });
  },
});
export const { clearSuccessMessage } = dailySales.actions;

export default dailySales.reducer;
